// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-choice {
    /* copied over from UnstyledButton */
    color: inherit;
    font: inherit;
    text-align: inherit;
    line-height: inherit;
    -webkit-font-smoothing: inherit;
    -moz-osx-font-smoothing: inherit;
    -webkit-appearance: none;
    appearance: none;
    background: none;
    border: none;
    display: block;
    box-sizing: border-box;
    padding: 0;
    cursor: pointer;
    margin: 0;
}

.text-choice-list {
    text-align: left;
    border-bottom: solid 1px var(--survey-border-color);
    margin-left: 10px;
    margin-right: 10px;
}

.text-choice-list .text-choice {
    border-top: solid 1px var(--survey-border-color);
    position: relative;
    width: 100%;
    display: flex;
    gap: 10px;
    cursor: pointer;
    align-items: center;
}

.text-choice-list .text-choice label {
    padding: 9px 0;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    position: relative;
    cursor: pointer;
    width: 100%;
    border: 1px solid transparent;
}

.text-choice-list .text-choice .text-choice-icon {
    color: #999;
    font-size: 16px;
    display: flex;
    align-items: center;
}

/* use some better colors probably */
.text-choice-list .text-choice-selected .text-choice-icon {
    color: #0067B1;
}

.text-choice-list .text-choice .info-button {
    color: #0067B1;
    cursor: pointer;
    margin-left: 10px;
}

.text-choice-list .text-choice .text-choice-text {
    flex-grow: 1;
    font-size: 16px;
}

.text-choice-list .text-choice .text-choice-description {
    color: #555;
    font-size: 14px;
    display: block;
}

.text-choice-list.text-choice-list-card-based {
    margin: 0;
    border-bottom: none;
}

.text-choice-list.text-choice-list-card-based .text-choice {
    padding-left: 10px;
    padding-right: 10px;
}


.text-choice-list.text-choice-list-v2 {
    margin: 0;
    border: none;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

 .text-choice-list.text-choice-list-v2 .text-choice {
    border-radius: 6px;
    padding: 0;
    border: none;
 }

.text-choice-list.text-choice-list-v2 .text-choice label {
    /* subtract 1 from normal padding due to borders */
    padding: 11px 15px;
    background: rgba(242, 243, 245, 1);
    border-radius: 6px;
    border: solid 1px rgba(242, 243, 245, 1);
}
.text-choice-list.text-choice-list-v2 .text-choice label:hover {
    background: rgba(232, 233, 235, 1);
}

/* Display keyboard interactions for custom inputs (survey v1 and v2) */
.text-choice-list .text-choice input:focus-visible + label {
    outline: solid 1px rgba(20, 110, 246, 1);
}

.text-choice-list .text-choice.text-choice-selected label {
    border: solid 1px rgba(20, 110, 246, 1);
}

.text-choice-list .text-choice .text-choice-icon {
    color: #aaa;
}

.text-choice-list .text-choice.text-choice-selected .text-choice-icon {
    color: rgba(20, 110, 246, 1);
}
`, "",{"version":3,"sources":["webpack://./src/components/Survey/Components/TextChoiceList/TextChoiceList.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,+BAA+B;IAC/B,gCAAgC;IAChC,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,sBAAsB;IACtB,UAAU;IACV,eAAe;IACf,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,mDAAmD;IACnD,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gDAAgD;IAChD,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA,oCAAoC;AACpC;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;;AAGA;IACI,SAAS;IACT,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;CAEC;IACG,kBAAkB;IAClB,UAAU;IACV,YAAY;CACf;;AAED;IACI,kDAAkD;IAClD,kBAAkB;IAClB,kCAAkC;IAClC,kBAAkB;IAClB,wCAAwC;AAC5C;AACA;IACI,kCAAkC;AACtC;;AAEA,uEAAuE;AACvE;IACI,wCAAwC;AAC5C;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,4BAA4B;AAChC","sourcesContent":[".text-choice {\n    /* copied over from UnstyledButton */\n    color: inherit;\n    font: inherit;\n    text-align: inherit;\n    line-height: inherit;\n    -webkit-font-smoothing: inherit;\n    -moz-osx-font-smoothing: inherit;\n    -webkit-appearance: none;\n    appearance: none;\n    background: none;\n    border: none;\n    display: block;\n    box-sizing: border-box;\n    padding: 0;\n    cursor: pointer;\n    margin: 0;\n}\n\n.text-choice-list {\n    text-align: left;\n    border-bottom: solid 1px var(--survey-border-color);\n    margin-left: 10px;\n    margin-right: 10px;\n}\n\n.text-choice-list .text-choice {\n    border-top: solid 1px var(--survey-border-color);\n    position: relative;\n    width: 100%;\n    display: flex;\n    gap: 10px;\n    cursor: pointer;\n    align-items: center;\n}\n\n.text-choice-list .text-choice label {\n    padding: 9px 0;\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n    position: relative;\n    cursor: pointer;\n    width: 100%;\n    border: 1px solid transparent;\n}\n\n.text-choice-list .text-choice .text-choice-icon {\n    color: #999;\n    font-size: 16px;\n    display: flex;\n    align-items: center;\n}\n\n/* use some better colors probably */\n.text-choice-list .text-choice-selected .text-choice-icon {\n    color: #0067B1;\n}\n\n.text-choice-list .text-choice .info-button {\n    color: #0067B1;\n    cursor: pointer;\n    margin-left: 10px;\n}\n\n.text-choice-list .text-choice .text-choice-text {\n    flex-grow: 1;\n    font-size: 16px;\n}\n\n.text-choice-list .text-choice .text-choice-description {\n    color: #555;\n    font-size: 14px;\n    display: block;\n}\n\n.text-choice-list.text-choice-list-card-based {\n    margin: 0;\n    border-bottom: none;\n}\n\n.text-choice-list.text-choice-list-card-based .text-choice {\n    padding-left: 10px;\n    padding-right: 10px;\n}\n\n\n.text-choice-list.text-choice-list-v2 {\n    margin: 0;\n    border: none;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n .text-choice-list.text-choice-list-v2 .text-choice {\n    border-radius: 6px;\n    padding: 0;\n    border: none;\n }\n\n.text-choice-list.text-choice-list-v2 .text-choice label {\n    /* subtract 1 from normal padding due to borders */\n    padding: 11px 15px;\n    background: rgba(242, 243, 245, 1);\n    border-radius: 6px;\n    border: solid 1px rgba(242, 243, 245, 1);\n}\n.text-choice-list.text-choice-list-v2 .text-choice label:hover {\n    background: rgba(232, 233, 235, 1);\n}\n\n/* Display keyboard interactions for custom inputs (survey v1 and v2) */\n.text-choice-list .text-choice input:focus-visible + label {\n    outline: solid 1px rgba(20, 110, 246, 1);\n}\n\n.text-choice-list .text-choice.text-choice-selected label {\n    border: solid 1px rgba(20, 110, 246, 1);\n}\n\n.text-choice-list .text-choice .text-choice-icon {\n    color: #aaa;\n}\n\n.text-choice-list .text-choice.text-choice-selected .text-choice-icon {\n    color: rgba(20, 110, 246, 1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
